import { addDays } from 'date-fns';

import { DateHelpers } from '@crm/shared/lib';

const ACTIVE_RANGE_DAYS = 7;

export const getDealDateBadgeClassName = (date: string) => {
    const dealDate = DateHelpers.getLocalDateStart(new Date(date));
    const today = DateHelpers.getLocalDateStart(new Date());

    if (DateHelpers.isSameLocalDate(dealDate, today)) {
        return '';
    }

    if (dealDate < today) {
        return 'bg-smtr-main-red-100';
    }

    return dealDate <= addDays(today, ACTIVE_RANGE_DAYS)
        ? 'bg-smtr-main-accent-50 text-smtr-main-accent-100'
        : 'bg-gray-200 text-gray-600';
};
